import { apiClient } from './apiClient';

export interface PendingApproval {
  id: string;
  domain: string;
  organization: string;
  requestType: 'New OD Member' | 'Domain Addition' | 'Policy Assignment';
  requestedBy: string;
  requestDate: string;
  targetPolicies: string[];
  priority: 'High' | 'Medium' | 'Low';
  reason: string;
  riskAssessment: 'High' | 'Medium' | 'Low';
  verificationStatus: 'Verified' | 'Documents Verified' | 'Pending Verification';
  lsegFeedSource?: string;
}

export interface ApprovalAction {
  id: string;
  approvalId: string;
  action: 'approve' | 'reject';
  actionBy: string;
  actionDate: string;
  notes?: string;
}

/**
 * Fetch all pending approvals
 */
export const getPendingApprovals = async (): Promise<PendingApproval[]> => {
  try {
    const response = await apiClient.get('/approvals');
    return (response.data as any)?.data || [];
  } catch (error) {
    console.error('Failed to fetch pending approvals:', error);
    throw error;
  }
};

/**
 * Approve a domain request with confirmation
 */
export const approveDomain = async (
  approvalId: string,
  confirmationText: string,
  notes?: string
): Promise<ApprovalAction> => {
  try {
    const response = await apiClient.post(`/approvals/${approvalId}/approve`, {
      confirmationText,
      notes
    });
    return (response.data as any)?.data?.approvalAction;
  } catch (error: any) {
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    console.error('Failed to approve domain:', error);
    throw error;
  }
};

/**
 * Reject a domain request with confirmation
 */
export const rejectDomain = async (
  approvalId: string,
  confirmationText: string,
  notes?: string
): Promise<ApprovalAction> => {
  try {
    const response = await apiClient.post(`/approvals/${approvalId}/reject`, {
      confirmationText,
      notes
    });
    return (response.data as any)?.data?.approvalAction;
  } catch (error: any) {
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    console.error('Failed to reject domain:', error);
    throw error;
  }
};